export default function Stub() {
    return (
        <div className="stub">
            <img src="https://i.imgur.com/VwNXS0o.jpg" alt="stub" />
        </div>
    );
}